<template>
  <div class="rightOperations">
    <div class="box">
      <el-button type="primary" size="small" :disabled="isNew" icon="el-icon-plus" @click="toRelease">发布</el-button>
      <el-button type="primary" size="small" :disabled="isNew" @click="toMergeOpen">合并图纸至文件</el-button>
      <!-- <el-button type="primary" size="small" plain @click="toSplitOpen">解除图纸合并</el-button> -->
      <el-button type="primary" size="small" :disabled="isNew" plain @click="toQuickAdd">快速添加</el-button>
      <el-button type="primary" size="small" :disabled="isNew" plain @click="toCopyAdd">复制添加</el-button>
      <el-button type="danger" size="small" :disabled="isNew" plain @click="toDel">删除</el-button>
      <el-button type="primary" size="small" :disabled="isNew" plain @click="toMove(1)">上移</el-button>
      <el-button type="primary" size="small" :disabled="isNew" plain @click="toMove(2)">下移</el-button>
      <el-button type="primary" size="small" :disabled="isNew" plain @click="toAutoOpen">自动编号</el-button>
      <el-button type="primary" size="small" :disabled="isSheetSet&&isNew" plain @click="toEditOpen">批量编辑</el-button>
      <el-button type="primary" size="small" :disabled="(isSheetSet&&isNew)||tableData.length==0" plain @click="toExportExcel">导出Excel</el-button>
      <!-- <el-button type="primary" size="small" plain @click="downTemplate">下载Excel模板</el-button>
      <el-button type="primary" size="small" plain @click="toImportOpen">导入Excel</el-button> -->
    </div>
    <!-- 弹框——合并图纸至文件 -->
    <el-dialog v-dialogDrag :visible.sync="mergeOpen" title="合并图纸至文件" width="27%" top="25vh"
      custom-class="sheetSetMerge" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="info">
        <i class="el-icon-warning"></i>
        <div>
          <span>合并图纸至文件操作，将会把所选图纸合并为单一文件的不同布局。您可以将所选图纸</span>
          <span v-for="(item,index) in selectionData" :key="index">【{{ item.drawingName }}】</span>
          <span>合并至已有文件或创建新文件。</span>
        </div>
      </div>

      <!-- 合并类型 -->
      <div class="mergeType">
        <el-radio v-model="mergeType" :label="1" @change="changeMergeType">创建新文件</el-radio>
        <el-radio v-model="mergeType" :label="2" @change="changeMergeType">合并至已有文件</el-radio>
      </div>

      <!-- 新文件名称 -->
      <div class="newFileName">
        <el-form ref="mergeForm" :model="mergeForm" label-position="top" label-width="80px" :rules="mergeRules" size="small">
          <el-form-item v-if="mergeType===1" label="新文件名称" prop="newFileName">
            <el-input v-model.trim="mergeForm.newFileName" placeholder="请输入文件名称" class="newFileNameInput" size="small" maxlength="50" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item v-if="mergeType===2" label="新文件名称" prop="searchFileName">
            <el-select v-model="mergeForm.searchFileName" placeholder="请选择已有文件" size="small" filterable>
              <el-option v-for="(item,index) in existFiles" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="mergeOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="mergeDetermine">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 弹框——解除图纸合并 -->
    <el-dialog v-dialogDrag :visible.sync="splitOpen" title="解除图纸合并" width="27%" top="25vh"
      custom-class="sheetSetSplit" :close-on-click-modal="false" :close-on-press-escape="false">
      <div v-if="splitType===2" class="newFileName">
        <div class="title">转移至文件:</div>
        <el-select v-model="searchFileName" placeholder="请选择已有文件" size="small" filterable>
          <el-option v-for="(item,index) in existFiles" :key="index" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <div v-if="selectionData.length" class="info">
        <div v-if="otherDrawingData.length">
          <span>当前【{{ selectionData[0].drawingName }}】所在【{{ selectionData[0].fileName }}】还包含图纸</span>
          <span v-for="(item,index) in otherDrawingData" :key="index">【{{ item }}】</span>
          <span>，是否需要全部解除合并？</span>
        </div>
        <div v-else>
          <span>当前【{{ selectionData[0].drawingName }}】所在【{{ selectionData[0].fileName }}】仅包含该文件，是否解除合并生成名称为【{{ selectionData[0].drawingName }}】的文件？</span>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="splitOpen = false">取 消</el-button>
        <el-button v-if="splitType===1" type="primary" size="small" @click="splitDetermine(0)">仅解除本图纸</el-button>
        <el-button v-if="splitType===1" type="primary" size="small" @click="splitDetermine(1)">解除全部</el-button>
        <el-button v-if="splitType===2" type="primary" size="small" @click="splitDetermine(0)">仅转移本图纸</el-button>
        <el-button v-if="splitType===2" type="primary" size="small" @click="splitDetermine(1)">转移全部</el-button>
      </div>
    </el-dialog>

    <!-- 弹框——自动编号 -->
    <el-dialog v-dialogDrag :visible.sync="autoOpen" title="自动编号" width="26%" top="18vh" custom-class="sheetSetAuto" :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- 图纸表操作按钮 -->
      <div class="buttons">
        <el-button type="primary" size="small" plain @click="toggerCheck">反选</el-button>
        <el-button type="primary" size="small" plain @click="autoPreview">预览</el-button>
        <el-button type="primary" size="small" plain @click="reduction">还原</el-button>
      </div>

      <!-- 图纸表 -->
      <div class="autoTable">
        <el-table ref="autoTable" height="251" border tooltip-effect="dark" highlight-current-row :data="autoTableData"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45" align="center">
          </el-table-column>
          <el-table-column label="图纸名称" align="center" show-overflow-tooltip prop="drawingName">
          </el-table-column>
          <el-table-column label="图纸编号" align="center" show-overflow-tooltip prop="drawingCode">
          </el-table-column>
        </el-table>
      </div>

      <!-- 编号设置 -->
      <div class="autoSet">
        <el-form ref="formLabelAlign" size="small" label-position="left" label-width="93px" :model="formLabelAlign" :rules="rules">
          <el-form-item label="前缀：">
            <el-input v-model.trim="formLabelAlign.preName" placeholder="请输入前缀"></el-input>
          </el-form-item>
          <el-form-item label="起始编号：" prop="autoNumber">
            <el-input v-model="formLabelAlign.autoNumber" placeholder="请输入起始编号"></el-input>
          </el-form-item>
          <el-form-item label="后缀：">
            <el-input v-model.trim="formLabelAlign.sufName" placeholder="请输入后缀"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="autoOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="autoDetermine">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 弹框——批量编辑 -->
    <el-dialog v-dialogDrag :visible.sync="editOpen" title="批量编辑" width="50%" top="16vh" custom-class="sheetSetEdit"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- 图框信息 -->
      <div class="frameInfo">
        <div class="head">
          <span class="title">图框信息</span>
        </div>

        <!-- 图表 -->
        <div class="editTable">
          <el-table ref="editTable" height="400" border :data="editTableData" tooltip-effect="dark" highlight-current-row
            @selection-change="editHandleSelectionChange">
            <el-table-column type="selection" width="45" align="center">
            </el-table-column>
            <el-table-column label="序号" type="index" width="60" align="center">
            </el-table-column>
            <el-table-column label="图纸编号" width="120" show-overflow-tooltip align="center" prop="drawingCode">
            </el-table-column>
            <el-table-column label="图纸名称" show-overflow-tooltip align="center" prop="drawingName">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 字段信息 -->
      <div class="fieldInfo">
        <div class="title">字段信息</div>
        <div class="fieldBox">
          <div class="top">
            <p style="width:83px">字段</p>
            <p style="width:100%">值</p>
          </div>
          <el-form ref="fieldForm" size="small" label-width="96px" :model="fieldFormData" class="fieldForm">
            <el-form-item label="图框模板">
              <el-select v-if="cur=='framName'" id="framName" v-model="fieldFormData.framName" placeholder="请选择"
                filterable @change="changeFram" @visible-change="visibleChange">
                <el-option v-for="item in framList" :key="item.borderId" :label="item.borderName" :value="item.borderName">
                </el-option>
              </el-select>
              <p v-else @click="modify('framName')">{{ fieldFormData.framName }}</p>
            </el-form-item>
            <el-form-item label="文件名称">
              <el-input v-if="cur=='fileName'" id="fileName" v-model="fieldFormData.fileName" size="small" maxlength="50"
                @blur="blurfieldInput">
                <i v-if="fieldFormData.fileName" slot="suffix">{{ fieldFormData.fileName.length }}/50</i>
              </el-input>
              <p v-else @click="modify('fileName')">{{ fieldFormData.fileName }}</p>
            </el-form-item>
            <el-form-item label="图纸等级">
              <el-select v-if="cur=='drawingLevelName'" id="drawingLevelName" v-model="fieldFormData.drawingLevelName"
                placeholder="请选择" filterable @change="changeDrawingLevel" @visible-change="visibleChange">
                <el-option v-for="(item,index) in drawingLevelList" :key="index" :label="item.cnName"
                  :value="item.cnName">
                </el-option>
              </el-select>
              <p v-else @click="modify('drawingLevelName')">{{ fieldFormData.drawingLevelName }}</p>
            </el-form-item>
            <el-form-item label="加长值">
              <el-select v-if="cur=='lengthValue'" id="lengthValue" v-model="fieldFormData.lengthValue"
                placeholder="请选择" filterable @visible-change="visibleChange">
                <el-option v-for="(item,index) in lengthValueList" :key="index" :label="item.enName"
                  :value="item.enName">
                </el-option>
              </el-select>
              <p v-else @click="modify('lengthValue')">{{ fieldFormData.lengthValue }}</p>
            </el-form-item>
            <el-form-item v-for="(item,index) in columnList" :key="index" :label="item.colCnName">
              <el-input v-if="cur==item.colId&&item.typeId==='1'" :id="item.colId" v-model="fieldFormData[item.colId]" size="small" maxlength="50"
                @blur="blurfieldInput(fieldFormData[item.colId])">
                <i v-if="fieldFormData[item.colId]" slot="suffix">{{ fieldFormData[item.colId].length }}/50</i>
              </el-input>
              <el-select v-else-if="cur==item.colId&&item.typeId==='2'" :id="item.colId" v-model="fieldFormData[item.colId]" multiple filterable
                placeholder="请选择" @visible-change="visibleChange" @change="changePeople(item.colId)">
                <el-option v-for="peopleItem in peopleList" :key="peopleItem.name" :label="peopleItem.name" :value="peopleItem.name">
                </el-option>
              </el-select>
              <el-cascader
                v-else-if="cur==item.colId&&item.typeId==='3'"
                :id="item.colId"
                v-model="fieldFormData[item.colId]"
                :show-all-levels="false"
                size="small"
                :options="stampList"
                :props="stampDefaultProps"
                clearable
                @change="changesSamp(item.colId)"
                @visible-change="visibleChangeSamp"
              ></el-cascader>
              <p v-else @click="modify(item.colId,fieldFormData[item.colId],item.typeId)">
                <span v-if="item.typeId==='3'">{{ fName(fieldFormData[item.colId]) }}</span>
                <span v-else>{{ fieldFormData[item.colId] }}</span>
              </p>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="editDetermine">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 弹框——导入Excel -->
    <el-dialog v-dialogDrag :visible.sync="excelOpen" title="导入Excel" width="35%" top="28vh"
      custom-class="sheetSetExcel" :close-on-click-modal="false" :close-on-press-escape="false">
      <div v-if="excelTableData.length" class="info">
        <span>发现重复的图纸编号或图纸名称，是否覆盖/跳过重复的图纸并继续导入？</span>
      </div>
      <!-- 重复图纸表 -->
      <div v-if="excelTableData.length" class="excelTable">
        <el-table ref="excelTable" height="450" border :data="excelTableData" tooltip-effect="dark">
          <el-table-column label="图纸编号" show-overflow-tooltip prop="drawingCode">
          </el-table-column>
          <el-table-column label="图纸名称" show-overflow-tooltip prop="drawingName">
          </el-table-column>
          <el-table-column label="操作" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-dropdown size="mini" trigger="click">
                <span class="el-dropdown-link" style="color:var(--theme-color)">
                  {{ scope.row.coverSkip }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="excelHandle(scope.row,'覆盖')">覆盖</el-dropdown-item>
                  <el-dropdown-item @click.native="excelHandle(scope.row,'跳过')">跳过</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 操作按钮 -->
      <div v-if="excelTableData.length" slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="fullCoverage">全部覆盖</el-button>
        <el-button size="small" plain @click="skipAll">全部跳过</el-button>
        <el-button size="small" plain @click="excelOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="excelDetermine">确 定</el-button>
      </div>
      <div v-else>
        <span>
          <div v-if="!fileList2.length">
            <div style="text-align: center;margin-top: 15px;margin-bottom: 15px;">
              <el-upload drag action="/" :before-upload="dataprogress1" :show-file-list="false"
                :http-request="httpRequest">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖拽至此区域，或<em>点击上传</em>
                </div>
                <div slot="tip" class="el-upload__tip">
                  仅支持xls、xlsx格式，文件大小不超过5M
                </div>
              </el-upload>
            </div>
          </div>
          <div v-if="fileList2.length" style="margin: 15px 0">
            <div
              style="text-align:center;border: 1px dashed #d9d9d9;border-radius:6px;width: 360px;margin: 0 auto;padding: 50px 0px;">
              <img :src="xlssrc" alt="" style="vertical-align: text-bottom;">
              <p><span>{{ fileList2[0].name }}</span></p>
            </div>
            <div style="text-align:center;margin-top:20px">
              <el-button size="small" type="primary" plain :loading="disabledone2" @click="newuplode">
                重新上传
              </el-button>
              <el-button size="small" type="primary" :loading="disabledone2" @click="suredaoru">
                确认导入
              </el-button>
            </div>
          </div>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sheetSetService from "@/CommonDP/service/sheetSet-service";
import requestprj from "@/CommonDP/service/standardPlan-service";
import { mapState } from "vuex";
import { templateDownload } from "@/CommonDP/utils";
import createProject from "@/CommonDP/service/createProject-service";
import personPlanService from "@/CommonDP/service/personPlan-service";
import stamp from "@/CommonDP/service/eSeal-service";

export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    const validateAutoNumber = (rule, value, callback) => {
      const idCardx = /^[0-9]*$/;
      if (value === "") {
        callback(new Error("请输入起始编号"));
      } else if (!idCardx.test(value)) {
        callback(new Error("起始编号只能是数字且不支持负数和小数"));
      } else {
        callback();
      }
    };
    return {
      existFiles: [], // 已有文件
      mergeOpen: false, // 弹框——合并图纸至文件
      mergeType: 1, // 合并类型
      // searchFileName: "", // 搜索的文件名称
      mergeForm: {
        newFileName: "",
        searchFileName: ""
      },
      splitOpen: false, // 弹框——解除图纸合并
      autoOpen: false, // 弹框——自动编号
      autoTableData: [], // 自动编号_表数据
      editOpen: false, // 弹框——批量编辑
      editTableData: [], // 批量编辑_表数据
      emptyFieldFormData: {
        enterpriseId: "",
        listId: "",
        framId: "",
        framName: "",
        fileName: "",
        prjId: "",
        lengthValue: "",
        drawingLevelId: "",
        drawingLevelName: "",
        dynamicFieldList: []
      },
      fieldFormData: {
        enterpriseId: "",
        listId: "",
        framId: "",
        framName: "",
        fileName: "",
        prjId: "",
        lengthValue: "",
        drawingLevelId: "",
        drawingLevelName: "",
        dynamicFieldList: []
      }, // 批量编辑-字段信息_表数据
      excelOpen: false, // 弹框——导入Excel
      excelTableData: [], // 导入Excel_表数据
      autoChooseList: [],
      formLabelAlign: {
        preName: "",
        autoNumber: "",
        sufName: ""
      },
      rules: {
        autoNumber: [{ required: true, trigger: "blur", validator: validateAutoNumber }]
      },
      mergeRules: {
        newFileName: [{ required: true, message: "请输入文件名称", trigger: "blur" }],
        searchFileName: [{ required: true, message: "请选择新文件名称", trigger: "change" }]
      },
      splitType: 1,
      otherDrawingData: [],
      editChooseList: [],
      flagArr: [
        "framId",
        "framName",
        "fileName",
        "prjId",
        "lengthValue",
        "drawingLevelId",
        "drawingLevelName"
      ],
      cur: "",
      framList: [],
      lengthValueList: [],
      fileList2: [], // 上传的文件      有文件 就展示文件列表页面 没文件就展示选择文件的页面
      xlssrc: require("@/CommonDP/assets/addpersonInfo/图表.png"),
      disabledone2: false, // 正在调用上传文件的接口
      coverSkip: "跳过",
      drawingLevelList: [],
      columnList: [],
      peopleList: [],
      stampList: [],
      stampDefaultProps: {
        children: "treeList",
        label: "sortName",
        value: "sortName",
        checkStrictly: true
      }
    };
  },
  computed: {
    ...mapState({
      folderData: (state) => state.sheetSet.folderData,
      selectionData: (state) => state.sheetSet.selectionData,
      rowData: (state) => state.sheetSet.rowData,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      isMajor: (state) => state.sheetSet.isMajor,
      prjInfo: (state) => state.projectMg.prjObj
    }),
    // 图纸集模块只能导出Excel
    isSheetSet() {
      if (this.folderData.folderId && this.folderData.folderNew === 1 && this.folderData.folderType === 51) {
        return false;
      } else {
        return true;
      }
    },
    isNew() {
      // 是新建的图纸集就返回false  其他的就返回true(只有新建的图纸集才能做上面的功能)
      if (this.folderData.childList === null) {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {},
  methods: {
    fName(val) {
      const v = val ? val.split(",")[val.split(",").length - 1] : '';
      return v;
    },
    // 导出Excel
    toExportExcel() {
      this.$emit("exportExcel");
    },
    // 处理excel重复图纸
    excelHandle(item1, item2) {
      item1.coverSkip = item2;
    },
    // 快速添加
    toQuickAdd() {
      if (this.folderData.folderId && this.folderData.folderType === 52) {
        this.$emit("quickAdd");
      } else {
        this.$message.warning("请先选择图纸集");
      }
    },
    toCopyAdd() {
      if (this.folderData.folderId && this.folderData.folderType === 52) {
        this.$emit("copyAdd");
      } else {
        this.$message.warning("请先选择图纸集");
      }
    },
    async toDel() {
      if (this.selectionData.length) {
        this.$confirm("您确定要删除这些数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(async () => {
            const list = this.selectionData.map((item) => {
              return item.drawingId;
            });
            await sheetSetService.prjDrawingSetPlanEditDatchDelete(list);
            this.$message.success("删除成功");
            this.$emit("queryList");
          })
          .catch(() => {});
      } else {
        this.$message.warning("请选择要删除的数据");
      }
    },
    async toMove(flag) {
      if (this.rowData.drawingId) {
        try {
          const params = {
            drawingId: this.rowData.drawingId,
            moveFlag: flag
          };
          await sheetSetService.prjDrawingSetPlanEditMove(params);
          let messageSuccess;
          flag === 1 ? (messageSuccess = "上移成功") : (messageSuccess = "下移成功");
          this.$message.success(`${messageSuccess}`);
          this.$emit("queryList");
        } catch (error) {
          console.log(error);
        }
      } else {
        let messageWarning;
        flag === 1 ? (messageWarning = "请选择上移的数据") : (messageWarning = "请选择下移的数据");
        this.$message.warning(`${messageWarning}`);
      }
    },
    async toAutoOpen() {
      if (this.folderData.folderId && this.folderData.folderType === 52) {
        const params = {
          keyWord: "",
          listId: this.folderData.folderId
        };
        const listRes = await sheetSetService.prjDrawingSetPlanEditList(params);
        this.autoTableData = listRes.data;
        this.formLabelAlign.preName = "";
        this.formLabelAlign.autoNumber = "";
        this.formLabelAlign.sufName = "";
        this.autoChooseList = [];
        this.autoTableData.forEach((item, index, arr) => {
          this.$set(item, "number", index);
          item.dynamicFieldList.forEach((item1, index, arr) => {
            if (item1.fieldId === 'init200000000007') {
              this.$set(item, "drawingName", item1.fieldValue);
            }
            if (item1.fieldId === 'init200000000013') {
              this.$set(item, "oldDrawingCode", item1.fieldValue);
              this.$set(item, "drawingCode", item1.fieldValue);
            }
          });
        });
        this.autoOpen = true;
        this.$nextTick(() => {
          this.$refs.formLabelAlign.resetFields();
        });
      } else {
        this.$message.warning("请先选择图纸集");
      }
    },
    handleSelectionChange(val) {
      this.autoChooseList = [];
      val.sort(function (o1, o2) {
        return o1.number - o2.number;
      });
      this.autoChooseList = val;
    },
    // 反选
    toggerCheck() {
      this.reduction();
      this.autoTableData.forEach((item) => {
        this.$refs.autoTable.toggleRowSelection(item);
      });
    },
    // 预览
    autoPreview() {
      this.$refs.formLabelAlign.validate(async (valid) => {
        if (valid) {
          if (this.autoChooseList.length) {
            await this.reduction();
            await this.autoPreviewTwo();
          } else {
            this.$message.warning("请勾选数据");
          }
        }
      });
    },
    // 预览
    autoPreviewTwo() {
      try {
        this.autoChooseList.forEach((item, index, arr) => {
          const newNumToS = (+this.formLabelAlign.autoNumber + index).toString();
          const oldNumLh = this.formLabelAlign.autoNumber.length;
          const lh = oldNumLh - newNumToS.length;
          let newNum = "";
          if (lh <= 0) {
            newNum = newNumToS;
          } else {
            newNum = newNumToS.padStart(oldNumLh - newNumToS.length + 1, "0");
          }
          item.drawingCode = this.formLabelAlign.preName + newNum + this.formLabelAlign.sufName;
          if (item.drawingCode.length > 50) {
            throw new Error('图纸编号不能大于50个字符');
          }
        });
      } catch (err) {
        this.$message.warning(err.message);
        this.reduction();
        return err.message;
      }
    },
    // 还原
    reduction() {
      this.autoTableData.forEach((item, index, arr) => {
        item.drawingCode = item.oldDrawingCode;
      });
    },
    // 自动编号确定按钮
    async autoDetermine() {
      this.$refs.formLabelAlign.validate(async (valid) => {
        if (valid) {
          if (this.formLabelAlign.autoNumber) {
            if (this.autoChooseList.length) {
              const res = await this.autoPreviewTwo();
              if (!res) {
                const params = this.autoChooseList.map((rule) => {
                  return {
                    drawingId: rule.drawingId,
                    drawingCode: rule.drawingCode
                  };
                });
                await sheetSetService.drawingCodeUpdate(params);
                this.autoOpen = false;
                this.$message.success("自动编号成功");
                this.$emit("queryList");
              }
            } else {
              this.$message.warning("请先勾选数据");
            }
          } else {
            this.$message.warning("请填写起始编号");
          }
        }
      });
    },
    async toMergeOpen() {
      if (this.selectionData.length) {
        await this.queryfileNameList();
        this.mergeOpen = true;
        this.mergeType = 1;
        this.mergeForm.newFileName = "";
        this.mergeForm.searchFileName = "";
        this.$nextTick(() => {
          this.$refs.mergeForm.resetFields();
        });
      } else {
        this.$message.warning("请选择要合并的数据");
      }
    },
    async queryfileNameList() {
      const fileNameList = await sheetSetService.prjFileNameList(this.folderData.folderId);
      this.existFiles = fileNameList.data;
    },
    // 合并图纸至文件 确定按钮
    async mergeDetermine() {
      this.$refs.mergeForm.validate(async (valid) => {
        if (valid) {
          const params = this.selectionData.map((rule) => {
            return {
              drawingId: rule.drawingId,
              fileName: this.mergeType === 1 ? this.mergeForm.newFileName : this.mergeForm.searchFileName
            };
          });
          await sheetSetService.prjDrawingToFileMerge(params);
          this.mergeOpen = false;
          this.$message.success("合并图纸成功");
          this.$emit("queryList");
        } else {
          return false;
        }
      });
    },
    changeMergeType() {
      this.mergeForm.newFileName = '';
      this.mergeForm.searchFileName = '';
      this.$nextTick(() => {
        this.$refs.mergeForm.resetFields();
      });
    },
    // async toSplitOpen() {
    //   if (this.selectionData.length === 1) {
    //     await this.queryOtherDrawingData();
    //     await this.queryfileNameList();
    //     this.splitOpen = true;
    //     this.splitType = 1;
    //     this.searchFileName = "";
    //   } else {
    //     this.$message.warning("请仅勾选一条数据");
    //   }
    // },
    // async queryOtherDrawingData() {
    //   const otherDrawing = await sheetSetService.prjDrawingByFileList(this.folderData.folderId, this.selectionData[0].fileName);
    //   const newArr = otherDrawing.data.filter((item) => item !== this.selectionData[0].drawingName);
    //   this.otherDrawingData = newArr;
    // },
    // async splitDetermine(flag) {
    //   if (this.splitType === 1 || this.searchFileName) {
    //     const params = {
    //       drawingId: this.selectionData[0].drawingId,
    //       fileName: this.searchFileName,
    //       listId: this.folderData.folderId,
    //       removeAll: flag
    //     };
    //     await sheetSetService.prjDrawingToFileunMerge(params);
    //     this.splitOpen = false;
    //     this.$message.success("解除图纸合并成功");
    //     this.$emit("queryList");
    //   } else {
    //     this.$message.warning("请选择转移至文件");
    //   }
    // },
    // 下载Excel模板
    downTemplate() {
      window.location = templateDownload();
    },
    // 批量编辑
    async toEditOpen() {
      await this.queryUserDict();
      const params = {
        keyWord: "",
        listId: this.folderData.folderId
      };
      const listRes = await sheetSetService.prjDrawingSetPlanEditList(params);
      this.editTableData = listRes.data;
      this.editTableData.forEach((item, index, arr) => {
        // 编辑的时候 可能列表里并没有新加的字段 所以要先初始化一遍
        this.columnList.forEach((col, colindex, colarr) => {
          this.$set(item, "drawingName", '');
          this.$set(item, "drawingCode", '');
          this.$set(item, col.colId, '');
          this.$set(item, col.colId + 'ValueId', '');
          this.$set(this.fieldFormData, col.colId, '');
          this.$set(this.fieldFormData, col.colId + 'ValueId', '');
          this.$set(this.emptyFieldFormData, col.colId, '');
          this.$set(this.emptyFieldFormData, col.colId + 'ValueId', '');
        });
      });
      this.editTableData.forEach((item, index, arr) => {
        item.dynamicFieldList.forEach((item1, index, arr) => {
          if (item1.fieldId === 'init200000000007') {
            this.$set(item, "drawingName", item1.fieldValue);
          } else if (item1.fieldId === 'init200000000013') {
            this.$set(item, "drawingCode", item1.fieldValue);
          } else {
            this.$set(item, item1.fieldId, item1.fieldValue);
            this.$set(item, item1.fieldId + 'ValueId', item1.fieldValueId);
            this.$set(this.fieldFormData, item1.fieldId, '');
            this.$set(this.fieldFormData, item1.fieldId + 'ValueId', '');
            this.$set(this.emptyFieldFormData, item1.fieldId, '');
            this.$set(this.emptyFieldFormData, item1.fieldId + 'ValueId', '');
          }
        });
      });
      this.editChooseList = [];
      this.cur = "";
      this.editOpen = true;
      this.$nextTick(() => {
        this.$refs.fieldForm.resetFields();
      });
    },
    editHandleSelectionChange(val) {
      this.editChooseList = val;
      this.cur = "";
      if (val.length) {
        const arr = val;
        const result = {};
        const temp = {};
        for (let i = 0; i < arr.length; ++i) {
          for (const j in arr[i]) {
            if (!temp[j]) {
              temp[j] = {};
              result[j] = [];
            }
            if (!temp[j][arr[i][j]]) {
              result[j].push(arr[i][j]);
            }
            temp[j][arr[i][j]] = arr[i][j];
          }
        }
        this.flagArr.forEach((item, index, arr) => {
          this.arrangementData(item, result);
        });
        this.columnList.forEach((item, index, arr) => {
          // 有多选情况的
          if (item.typeId === "2") {
            this.arrangementUserData(item.colId, result[item.colId]);
          } else if (item.typeId === "3") {
            this.arrangementSampData(item.colId, result);
          } else {
            this.arrangementData(item.colId, result);
          }
        });
      } else {
        this.fieldFormData = JSON.parse(JSON.stringify(this.emptyFieldFormData));
      }
    },
    arrangementSampData(item, result) {
      if (result[item]) {
        this.fieldFormData[item] = result[item].length === 1 ? result[item][0] : "";
      } else {
        this.fieldFormData[item] = '';
      }
    },
    arrangementData(item, result) {
      this.fieldFormData[item] = result[item].length === 1 ? result[item][0] : "";
    },
    arrangementUserData(flagitem, userData) {
      const res = userData.map((item) => {
        return item.split(",");
      });
      const bool = res.every((item, index, array) => {
        return item.sort().toString() === res[0].sort().toString();
      });
      if (bool) {
        this.fieldFormData[flagitem] = res[0].map((item) => item).join(",");
      } else {
        this.fieldFormData[flagitem] = "";
      }
    },
    modify(flag, val, typeId) {
      if (this.editChooseList.length) {
        this.cur = flag;
        if (typeId === '2' || typeId === '3') {
          this.fieldFormData[flag] = val ? val.split(",") : [];
        }
        this.$nextTick(() => {
          const ref = flag;
          document.getElementById(ref).focus();
        });
      } else {
        this.$message.warning("请先选择要编辑的数据");
      }
    },
    async editDetermine() {
      if (this.editChooseList.length) {
        if (!this.fieldFormData.fileName) {
          this.$message({
            message: "文件名称不能为空",
            type: "warning"
          });
          return;
        }
        const regExp = new RegExp('[\\\\|/:*<>?"]');
        if (regExp.test(this.fieldFormData.fileName)) {
          this.$message.warning('文件名称不能包含以下字符:\\ / : * " ? < > |');
          return;
        }
        if (!this.fieldFormData.framName) {
          this.$message({
            message: "图框模板不能为空",
            type: "warning"
          });
          return;
        }
        if (!this.fieldFormData.lengthValue) {
          this.$message({
            message: "加长值不能为空",
            type: "warning"
          });
          return;
        }
        this.editChooseList.forEach((item, index, arr) => {
          this.flagArr.forEach((flag) => {
            item[flag] = this.fieldFormData[flag];
          });
          item.dynamicFieldList.forEach((flag2) => {
            if (flag2.fieldId !== 'init200000000007' && flag2.fieldId !== 'init200000000013') {
              flag2.fieldValue = this.fieldFormData[flag2.fieldId];
              flag2.fieldValueId = this.fieldFormData[flag2.fieldId + 'ValueId'];
            }
          });
        });
        await sheetSetService.prjDrawingSetPlanEditBatchUpdate(this.editChooseList);
        this.$message.success("批量修改成功");
        this.$emit("queryList");
        this.editOpen = false;
      } else {
        this.$message.warning("请先选择要编辑的数据");
      }
    },
    blurfieldInput() {
      this.cur = "";
    },
    async queryUserDict() {
      if (this.isMajor.specId) {
        const framRes = await requestprj.getStandardFiles(this.prjInfo.prjId, this.enterpriseId);
        this.framList = framRes.data;
        const lengthValueRes = await createProject.dicList("Extended");
        this.lengthValueList = lengthValueRes.data;
        const drawingLevelueRes = await createProject.dicList("DrawingLevel");
        this.drawingLevelList = drawingLevelueRes.data;
        const columnRes = await sheetSetService.getFrameColumnList(this.enterpriseId);
        this.columnList = [];
        columnRes.data.forEach((item, index, arr) => {
          if (item.colId !== 'init200000000007' && item.colId !== 'init200000000013') {
            this.columnList.push(item);
          }
        });
        const params = {
          specId: this.isMajor.specId,
          prjId: this.prjInfo.prjId,
          enterpriseId: this.enterpriseId
        };
        const res = await personPlanService.queryPersonList(params);
        this.peopleList = res.data;
        const stampRes = await stamp.getElectronic(this.enterpriseId);
        this.stampList = this.getTreeData(stampRes.data) || [];
      }
    },
    getTreeData(data) {
      for (var i = 0;i < data.length > 0;i++) {
        if (data[i].treeList == null || data[i].treeList.length <= 0) {
          data[i].treeList = undefined;
        } else {
          this.getTreeData(data[i].treeList);
        }
      }
      return data;
    },
    changeFram(val) {
      if (val) {
        this.fieldFormData.framId = this.framList.find((ele) => ele.borderName === val).borderId;
      } else {
        this.fieldFormData.framId = "";
      }
    },
    changeDrawingLevel(val) {
      if (val) {
        this.fieldFormData.drawingLevelId = this.drawingLevelList.find((ele) => ele.cnName === val).id;
      } else {
        this.fieldFormData.drawingLevelId = "";
      }
    },
    toImportOpen() {
      if (this.folderData.folderId && this.folderData.folderType === 52) {
        this.excelOpen = true;
        this.fileList2 = [];
        this.excelTableData = [];
      } else {
        this.$message.warning("请先选择图纸集");
      }
    },
    // 上传1
    dataprogress1(file) {
      const tt = file.name;
      const ttt = tt.split(".");
      const ttl = ttt.length;
      const isXLSX = ttt[ttl - 1] === "xlsx";
      const isXLS = ttt[ttl - 1] === "xls";
      const isPG = isXLSX || isXLS;
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isPG) {
        this.$message({
          showClose: true,
          message: "上传文件只能是 .xls .xlsx 格式!",
          type: "warning"
        });
      } else if (!isLt2M) {
        this.$message({
          showClose: true,
          message: "上传文件大小不能超过 5M!",
          type: "warning"
        });
      }
      return isPG && isLt2M;
    },
    // 上传2
    async httpRequest({ file }) {
      this.fileList2.push(file);
    },
    // 重新上传
    newuplode() {
      this.disabledone2 = false;
      this.fileList2 = [];
    },
    // 确认导入
    async suredaoru() {
      this.disabledone2 = true;
      const data = new FormData();
      data.append("file", this.fileList2[0]);
      data.append("listId", this.folderData.folderId);
      data.append("prjId", this.prjInfo.prjId);
      try {
        const res = await sheetSetService.prjDrawingSetPlanEditImport(data);
        this.excelTableData = res.data;
        this.$message.success("导入Excel成功");
        this.$emit("queryList");
        if (this.excelTableData.length) {
          this.excelTableData.forEach((item, index, arr) => {
            this.$set(item, "coverSkip", "跳过");
            this.$set(item, "listId", this.folderData.folderId);
            this.$set(item, "prjId", this.prjInfo.prjId);
          });
        } else {
          this.excelOpen = false;
        }
        this.disabledone2 = false;
      } catch (error) {
        this.disabledone2 = false;
      }
    },
    async excelDetermine() {
      const bool = this.excelTableData.some((item, index, array) => {
        return item.coverSkip === "覆盖";
      });
      // 只要有一个等于覆盖的就返回true，如果所有都不等于覆盖 都是跳过 则返回false
      if (bool) {
        const newArr = this.excelTableData.filter((item) => item.coverSkip === "覆盖");
        await sheetSetService.prjDrawingSetPlanEditBatchImport(newArr);
        this.$message.success("操作成功");
        this.excelOpen = false;
        this.$emit("queryList");
      } else {
        this.$message.success("操作成功");
        this.excelOpen = false;
      }
    },
    // 全部覆盖
    async fullCoverage() {
      await sheetSetService.prjDrawingSetPlanEditBatchImport(this.excelTableData);
      this.$message.success("操作成功");
      this.excelOpen = false;
      this.$emit("queryList");
    },
    // 发布
    async toRelease() {
      await sheetSetService.prjDrawingSetPlanEditPublish(this.folderData.folderId);
      this.$message.success("发布成功");
    },
    // 全部跳过
    skipAll() {
      this.$message.success("操作成功");
      this.excelOpen = false;
    },
    visibleChange(val) {
      if (!val) {
        this.fieldFormData[this.cur] = this.fieldFormData[this.cur].toString();
        this.cur = "";
      }
    },
    visibleChangeSamp(val) {
      if (!val) {
        this.fieldFormData[this.cur] = this.fieldFormData[this.cur].toString();
        this.cur = "";
      }
    },
    changePeople(val) {
      this.fieldFormData[val + 'ValueId'] = this.getNameList(this.fieldFormData[val], this.peopleList);
    },
    getNameList(names, list) {
      const ids = [];
      names.forEach((ele) => {
        list.forEach((res) => {
          if (ele === res.name) {
            ids.push(res.userId);
          }
        });
      });
      return ids.toString();
    },
    async changesSamp(val) {
      const newval = this.fieldFormData[val][this.fieldFormData[val].length - 1];
      await this.getStampNameList(val, newval, this.stampList);
    },
    getStampNameList(val, str, list) {
      list.forEach((ele) => {
        if (ele.sortName === str) {
          this.fieldFormData[val + 'ValueId'] = ele.sortID;
          return;
        } else {
          if (ele.treeList) {
            this.getStampNameList(val, str, ele.treeList);
          }
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.rightOperations {
  .box {
    .el-button {
      padding: 8px 10px !important;
      margin: 0 12px 0 0 !important;

      /deep/ i {
        font-size: 13px;
      }
    }
  }
}
</style>
<style lang="scss">
.sheetSetMerge {
  border-radius: 5px;

  .el-dialog__header {
    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;
    }
  }

  .el-dialog__body {
    padding: 0 !important;

    .info {
      padding: 18px 5px;

      display: flex;

      i {
        padding: 3px 5px;
        font-size: 14px;
        color: #ff9701;
      }

      span {
        font-size: 14px;
        line-height: 20px;
      }
    }

    .mergeType {
      padding: 18px 25px;
    }

    .newFileName {
      padding: 5px 35px 65px 25px;

      .title {
        padding: 10px 0;
        font-size: 14px;
        line-height: 20px;
      }
      .el-select {
        width: 100%;
      }
      .newFileNameInput{
        .el-input__inner{
          padding-right:40px;
        }
      }
    }
  }
}

.sheetSetSplit {
  border-radius: 5px;

  .el-dialog__header {
    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;
    }
  }

  .el-dialog__body {
    padding: 0 !important;

    .info {
      padding: 18px 28px;
      span {
        font-size: 14px;
        line-height: 20px;
      }
    }
    .splitType {
      padding: 18px 25px;
      padding-bottom: 10px;
    }

    .newFileName {
      padding: 5px 35px 5px 25px;

      .title {
        padding: 10px 0;
        font-size: 14px;
        line-height: 20px;
      }

      .el-select {
        width: 100%;
      }
    }
  }
}

.sheetSetAuto {
  border-radius: 5px;

  .el-dialog__header {
    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;
    }
  }

  .el-dialog__body {
    padding: 0 !important;

    .buttons {
      width: 100%;
      padding: 10px 20px;
      display: flex;
      flex-direction: row;
    }

    .autoTable {
      padding: 10px 20px;
      padding-top: 0px;
      .el-table {
        max-height: 300px;

        .el-table__cell {
          padding: 5px 0 !important;
          color: var(--key-color);
        }
      }
    }

    .autoSet {
      padding: 10px 22px 30px;
    }
  }
}

.sheetSetEdit {
  border-radius: 5px;

  .el-dialog__header {
    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;
    }
  }

  .el-dialog__body {
    height: 460px;
    padding: 0 !important;
    display: flex;

    .frameInfo {
      width: 70%;
      height: 100%;
      border-right: 1px solid #ebefff;

      display: flex;
      flex-direction: column;

      .head {
        width: 100%;
        padding: 1vh 2vh;

        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        .title {
          font-size: 14px;
          color: #3f4a56;
        }
      }

      .editTable {
        width: 100%;
        padding: 5px 2vh;
        flex-grow: 2;

        .el-table {
          max-height: 100%;

          .el-table__cell {
            padding: 5px 0 !important;
            color: var(--key-color);
          }
        }
      }
    }

    .fieldInfo {
      width: 30%;
      height: 100%;

      display: flex;
      flex-direction: column;

      .title {
        width: 100%;
        height: 38px;
        padding: 0 1vh 1vh;
        font-size: 14px;
        color: #3f4a56;

        display: flex;
        align-items: flex-end;
      }

      .fieldBox {
        width: 100%;
        padding: 0 1vh;
        flex-grow: 2;
        .top {
          display: flex;
          flex-direction: row;
          background: #f7f9ff;
          p {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            text-align: center;
          }
        }
        .fieldForm {
          overflow-x: auto;
          height: 385px;
          p {
            text-align: center;
            height: 35px;
            line-height: 35px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .el-form-item {
            border-bottom: 1px solid rgba(46, 91, 255, 0.1);
            margin-bottom: 0px;
            .el-form-item__label {
              text-align: center;
            }
            .el-input__inner {
              height: 35px;
              line-height: 35px;
              padding-right: 39px;
            }
            .el-date-editor.el-input {
              width: 177px;
            }
          }
        }
      }
    }
  }
}

.sheetSetExcel {
  border-radius: 5px;

  .el-dialog__header {
    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;
    }
  }

  .el-dialog__body {
    padding: 0 !important;

    .info {
      padding: 18px 25px;

      span {
        padding-right: 20px;
        font-size: 14px;
        line-height: 20px;
      }
    }

    .excelTable {
      width: 100%;
      height: 27vh;
      padding: 0 20px;
      margin-bottom: 20px;
      .el-table {
        max-height: 100%;

        .el-table__cell {
          padding: 5px 0 !important;
          color: var(--key-color);
        }
      }
    }
  }
}
</style>
